import { EventRouter } from "../../../../common/events"
import type { IFeedbackFormShowData } from "./userFeedbackModal"


export const openFeedbackForm = new EventRouter<IFeedbackFormShowData>("openFeedbackForm")
